module.exports = __webpack_public_path__ + "images/aevitaee03ffca8f64b20ad1aa856d8b471e517.png";